@if (!isOverlay && !isSplashScreenHidden) {
  <a
    [link]="linkUrl"
    class="cursor-pointer"
  >
    <img
      [src]="image?.url"
      class="w-full object-contain h-screen"
    />
  </a>
}
@if (isOverlay && !isSplashScreenHidden) {
  <a
    [link]="linkUrl"
    (click)="validateSplashScreen()"
    class="z-100 fixed h-full w-full cursor-pointer top-0 left-0"
    [style.background]="backgroundColor | contentBuilderColor: 'neutral-100'"
  >
    <img
      [src]="image?.url"
      class="w-full object-contain h-screen"
    />
  </a>
}
